import { BrowserRouter as Router, Routes, Route } from 'react-router'
import { lazy, Suspense } from 'react'

import InvoicesList from 'features/invoices/components/InvoicesList'
import InvoiceShow from 'features/invoices/components/InvoiceShow'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import reactQueryConfig from 'reactQueryConfig'
import { ToastProvider } from './contexts/ToastContext'
import AppBreadcrumb from './components/AppBreadcrumb'
import PageTitle from './components/PageTitle'
import FormSkeleton from 'shared/ui/Skeletons/FormSkeleton'
import ErrorBoundary from 'shared/ui/Feedback/ErrorBoundary'
import NotFound from 'shared/ui/Feedback/NotFound'
import { routes } from './routes'

const InvoiceCreate = lazy(() => import('features/invoices/components/InvoiceCreate'))
const InvoiceEdit = lazy(() => import('features/invoices/components/InvoiceEdit'))

const queryClient = new QueryClient(reactQueryConfig)

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <div className="container-xxl">
          <Router>
            <AppBreadcrumb />
            <main>
            <PageTitle />
            <ErrorBoundary>
              <Routes>
                <Route
                  path={routes.invoices.new}
                  element={
                    <Suspense fallback={<FormSkeleton />}>
                      <InvoiceCreate />
                    </Suspense>
                  }
                />
                <Route path={routes.invoices.patterns.show} Component={InvoiceShow} />
                <Route
                  path={routes.invoices.patterns.edit}
                  element={
                    <Suspense fallback={<FormSkeleton />}>
                      <InvoiceEdit />
                    </Suspense>
                  }
                />
                <Route path={routes.invoices.list} Component={InvoicesList} />
                <Route path="*" element={<NotFound title="Page not found" subTitle="The page you're looking for doesn't exist." backLabel="Back to invoices" />} />
              </Routes>
            </ErrorBoundary>
            </main>
          </Router>
        </div>
      </ToastProvider>
    </QueryClientProvider>
  )
}

export default App
